import { Component, HostBinding, EventEmitter, Output, Input } from '@angular/core';
import { IconType } from '../icon/icon-types';

@Component({
  selector: 'suka-popover-action-item',
  template: `
    <button type="button" (click)="onClick($event)">
      <div class="action-list__item__content">
        <suka-icon *ngIf="icon" [icon]="icon" class="popover__icon"></suka-icon>
        <ng-content></ng-content>
      </div>
    </button>
  `,
})
export class PopoverActionItem {
  @HostBinding('class.popover__action-list__item') baseClass = true;
  @HostBinding('class.action-list__item--destructive') @Input() destructive = false;
  @Input() icon: IconType;

  @Output() selected = new EventEmitter();

  onClick($event) {
    this.selected.emit($event);
  }
}
